import React from 'react';
import { Link } from '@commons/link/Link';
import cx from 'classnames';

import arrow from './images/arrow-top-right.svg';

import * as styles from './webinars-container.module.scss';

export const WebinarsContainer = ({ classNames: { container } = {}, webinars }) => {
  return (
    <div className={cx(styles.containerWithWebinars, container)}>
      {webinars.map((webinar) => (
        <Link
          key={webinar.title}
          href={webinar.link}
          className={styles.webinarContainer}
          target="_self"
          style={{ background: webinar.background }}
        >
          <div className={styles.webinarText}>
            <span className={styles.webinarTitle}>{webinar.title}</span>
            <span className={styles.webinarSubtitle}>{webinar.subtitle}</span>
            <img src={arrow} alt={webinar.title} className={styles.webinarArrow} />
          </div>
        </Link>
      ))}
    </div>
  );
};
